(ns app.bundle-social-youtube.platform
  "YouTube channels through bundle.social: a Short with one video, a
   title, the caption as its description, the visibility (public by
   default) and the
   made-for-kids and altered-or-synthetic flags.

   Only data and pure functions, see `app.bundle-social.platforms` for
   the keys. New YouTube connections go through bundle.social, while
   the channels connected before keep Storrito's own integration
   (`slices/youtube-posting`). Both share the scheduling page's YouTube
   group and its \"YouTube options\" card (`:post-type/destination-group`,
   `:post-type/options-card`). A Short of bundle.social is billed as a
   social post, and so is a video of `upload-youtube-video`
   (`slices/api-youtube-video`), which the API uploads through the same
   channels. Launched 2026-10-21 together with that procedure."
  (:require [app.bundle-social.text :as text]
            [clojure.string :as str]
            [storrito.caption-limits :as caption-limits]))

(defn icon
  "Font Awesome's youtube brand icon."
  [classes]
  [:svg {:xmlns "http://www.w3.org/2000/svg"
         :viewBox "0 0 576 512"
         :fill "currentColor"
         :aria-hidden "true"
         :class classes}
   [:path {:d "M549.7 124.1c-6.3-23.7-24.8-42.3-48.3-48.6C458.8 64 288 64 288 64S117.2 64 74.6 75.5c-23.5 6.3-42 24.9-48.3 48.6C15 167 15 256.4 15 256.4s0 89.4 11.3 132.3c6.3 23.7 24.8 41.5 48.3 47.8C117.2 448 288 448 288 448s170.8 0 213.4-11.5c23.5-6.3 42-24.2 48.3-47.8C561 345.8 561 256.4 561 256.4s0-89.4-11.3-132.3zM232 337.6V175.2l142.7 81.2L232 337.6z"}]])

(def max-title-length
  100)

(defn post-data
  "The `data.YOUTUBE` entry of a bundle.social post. The visibility is
   chosen in lower case, as Storrito's own YouTube integration stores
   it; bundle.social takes it in upper case. The scheduling page asks for
   a title; without one the Short is named after the media, or
   \"YouTube Short\" when the media has no name either."
  [{:keys [title text options upload-id]}]
  (let [short-title (or (:title options) (not-empty title) "YouTube Short")]
    (cond-> {:type "SHORT"
             :uploadIds [upload-id]
             :text (text/shorten short-title max-title-length)
             :privacy (str/upper-case (or (:privacy options) "public"))
             :madeForKids (true? (:made-for-kids options))
             :containsSyntheticMedia (true? (:ai-generated options))}
      ;; YouTube counts the description's bytes, see
      ;; `:post-type/max-text-bytes`.
      (seq text)
      (assoc :description (text/shorten-bytes text caption-limits/youtube-description-max-bytes)))))

(def platform
  {:social-platform/id "YOUTUBE"
   :social-platform/key :bundle-youtube
   :social-platform/name "YouTube"
   :social-platform/account-noun "YouTube channel"
   :social-platform/channel-noun "channel"
   :social-platform/channel-nouns "channels"
   :social-platform/icon icon
   :social-platform/text-class ["text-red-600"]
   :social-platform/pill-class ["bg-red-50" "border-red-200" "text-red-700"]
   :social-platform/launched? true
   ;; The accounts connected before bundle.social, shown and removed on
   ;; the Social Accounts page too.
   :social-platform/own-integration
   {:delete-command :command/youtube-delete
    :id-key :youtube.user/id
    :same-ids? true}
   :social-platform/connect-card
   {:eyebrow "YouTube Shorts"
    :description "Connect a YouTube channel for scheduled YouTube Shorts and for videos uploaded through the Storrito API."
    :button-text "Connect YouTube"
    :style {:card-class ["border-red-200" "bg-white" "hover:border-red-300"]
            :eyebrow-class ["bg-red-50" "text-red-600" "ring-red-100"]
            :icon-class ["bg-red-600" "text-white" "ring-red-200"]
            :title-class ["text-gray-900"]
            :description-class ["text-gray-600"]
            :button-class ["bg-red-600" "text-white" "hover:bg-red-700"]
            :rail-class ["bg-red-600"]}}
   :social-platform/post-data post-data
   ;; Like Storrito's own YouTube integration: Shorts up to 3 minutes,
   ;; a description up to 5,000 characters
   ;; (https://info.bundle.social/api-reference/platforms/youtube).
   :social-platform/post-types
   [{:post-type/id "SHORT"
     :post-type/kind :bundle-youtube-short
     :post-type/label "YouTube Short"
     :post-type/group-label "YouTube"
     :post-type/destination-group :youtube
     :post-type/options-card :youtube
     :post-type/media #{:video}
     :post-type/max-duration-seconds 180
     :post-type/caption? true
     :post-type/max-text-length 5000
     :post-type/max-text-bytes caption-limits/youtube-description-max-bytes
     :post-type/options
     [{:option/key :title
       :option/type :text
       :option/label "YouTube title"
       :option/max-length max-title-length
       :option/default :media-name}
      {:option/key :privacy
       :option/label "Visibility"
       :option/choices [{:choice/value "public" :choice/label "Public"}
                        {:choice/value "unlisted" :choice/label "Unlisted"}
                        {:choice/value "private" :choice/label "Private"}]}
      {:option/key :made-for-kids
       :option/type :checkbox
       :option/label "Made for kids"}
      {:option/key :ai-generated
       :option/type :checkbox
       :option/label "Altered or synthetic media"}]}]})
